if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    getRedirectUrl() {
      const direct = (this.dataset.redirectUrl || '').trim();
      let baseUrl = direct;

      if (!baseUrl) {
        const section = this.closest('[id^="shopify-section-"]');
        const picker = section?.querySelector('.collection-picker[data-redirect-after-add]');
        baseUrl = (picker?.dataset.redirectAfterAdd || '').trim();
      }

      if (!baseUrl) return '';
      return this.mergeCurrentSearchParams(baseUrl);
    }

    getMultiplyByDnaSetting() {
      const direct = this.dataset.multiplyByDna;
      if (direct !== undefined && direct !== '') {
        return direct === 'true';
      }

      const section = this.closest('[id^="shopify-section-"]');
      const picker = section?.querySelector('.collection-picker[data-multiply-by-dna]');
      if (picker) {
        return picker.dataset.multiplyByDna === 'true';
      }

      return null;
    }

    mergeCurrentSearchParams(url) {
      const search = window.location.search;
      if (!search || search === '?') return url;

      try {
        const merged = new URL(url, window.location.origin);
        const currentParams = new URLSearchParams(search);
        currentParams.forEach((value, key) => {
          if (!merged.searchParams.has(key)) {
            merged.searchParams.set(key, value);
          }
        });
        return merged.pathname + merged.search + merged.hash;
      } catch (_) {
        const joiner = url.includes('?') ? '&' : '?';
        return url + joiner + search.slice(1);
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      const multiplyByDna = this.getMultiplyByDnaSetting();

      if (multiplyByDna === false) {
        formData.set('quantity', 1);
      } else {
        const urlParams = new URLSearchParams(window.location.search);
        const qttParam = urlParams.get('qtt') || urlParams.get('missingDNA');
        const qttValue = Number.parseInt(qttParam, 10);
        if (Number.isInteger(qttValue) && qttValue > 0) {
          formData.set('quantity', qttValue);
        }
      }
      const redirectUrl = this.getRedirectUrl();
      if (!redirectUrl && this.dataset.cartType != 'page' && this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (this.dataset.cartType == 'page') {
            window.location = window.routes.cart_url;
            return;
          } else if (redirectUrl) {
            window.location.assign(redirectUrl);
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
